module.exports = __webpack_public_path__ + "static/media/wristband.64ad6490.png";